module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Camera-eafb92a855b0fdd41e35776be812ee31.svg";